/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextActionCheckIcon20Regular = forwardRef('TextActionCheckIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 5a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 5Z" }),
        React.createElement("path", { d: "M3.75 8.25a.75.75 0 0 0 0 1.5h12.5a.75.75 0 0 0 0-1.5H3.75Z" }),
        React.createElement("path", { d: "M3.75 12.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z" }),
        React.createElement("path", { d: "M19.593 13.03a.75.75 0 1 0-1.06-1.06l-4.025 4.024a.188.188 0 0 1-.266 0l-1.837-1.837a.75.75 0 1 0-1.06 1.06l1.837 1.838a1.687 1.687 0 0 0 2.386 0l4.025-4.025Z" })));
});
